var _WhereEnumerator_enumerator, _WhereEnumerator_predicate, _WhereEnumerator_currentItem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class WhereEnumerator extends EnumeratorBase {
    constructor(enumerator, predicate) {
        super();
        _WhereEnumerator_enumerator.set(this, void 0);
        _WhereEnumerator_predicate.set(this, void 0);
        _WhereEnumerator_currentItem.set(this, void 0);
        __classPrivateFieldSet(this, _WhereEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _WhereEnumerator_predicate, predicate, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _WhereEnumerator_currentItem, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _WhereEnumerator_currentItem, "f");
    }
    moveNext() {
        __classPrivateFieldSet(this, _WhereEnumerator_currentItem, this.peek(), "f");
        if (__classPrivateFieldGet(this, _WhereEnumerator_currentItem, "f") === undefined) {
            return false;
        }
        return __classPrivateFieldGet(this, _WhereEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        for (;;) {
            const item = __classPrivateFieldGet(this, _WhereEnumerator_enumerator, "f").peek();
            if (item === undefined) {
                return;
            }
            if (__classPrivateFieldGet(this, _WhereEnumerator_predicate, "f").call(this, item)) {
                return item;
            }
            if (!__classPrivateFieldGet(this, _WhereEnumerator_enumerator, "f").moveNext()) {
                break;
            }
        }
    }
    reset() {
        __classPrivateFieldGet(this, _WhereEnumerator_enumerator, "f").reset();
    }
}
_WhereEnumerator_enumerator = new WeakMap(), _WhereEnumerator_predicate = new WeakMap(), _WhereEnumerator_currentItem = new WeakMap();
